import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Business Client Name',
    field: 'businessClientName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Site ID',
    field: 'siteId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Site Name',
    field: 'siteName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Patrol Name',
    field: 'patrolName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  { headerName: 'Frequency', field: 'frequency', width: LIST_WIDTH.default },
  {
    headerName: 'Checkpoints',
    field: 'checkpoints',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'QR Code',
    field: 'btnData',
    width: LIST_WIDTH.s,
    cellRenderer: 'downloadBtn',
    cellRendererParams: {
      columnKey: 'patrolName',
    },
  },
  {
    field: 'departments',
    headerName: 'Departments',
    width: LIST_WIDTH.sm,
  },
];
